import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function DaVinciBorn() {
  const dateTexts = ['1452年', '4月', '15日'];
  const title = 'レオナルド・ダヴィンチ誕生';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2022/01/CIMG2283.jpeg'
  const description = (
    <>
      {'後のS.E.A.重要メンバーであるレオナルド・ダヴィンチが誕生する。'}
      {'彼は芸術分野だけでなく、化学、工学など多くの学問に精通し研究を行なっていた。'}
    </>
  );

  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
      objectPosition="20%"
    />
  );
}

export default DaVinciBorn;
